

<div class="custom-answer__group custom-answer__group--value form-group mb-0" id="ca-example-8">
  <div class="custom-answer custom-answer--slider">
    <div class="custom-answer__title">
      <label class="custom-input custom-input--checkbox custom-input--answer">
        <input type="checkbox" [checked]="checkChecked()" (click)="isAllowed()" name="checkbox-answer-example-1">
        <span class="custom-input__indi"></span>
        <span class="custom-input__label">{{question?.question_copy}}</span>
      </label>
    </div>
    @if (!hidePrem) {
      <div class="custom-answer__amount">
        @if (processing) {
          <p>Processing...</p>
        }
        <p class="is-inactive" >@if (!processing) {
          <span><strong>{{ questionService?.accounting?.formatMoney(premium)}}</strong>/{{questionService?.currency?.display_freq}}</span>
        }</p>
      </div>
    }
    <div class="custom-answer__slider" [ngClass]="checkChecked() ? 'is-active' : ''">
      <div class="custom-rangeslider">
        <div [id]="'slider'+uniqueId" class="custom-rangeslider__control noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr">

          <div class="noUi-pips noUi-pips-horizontal">
            <div class="noUi-marker noUi-marker-horizontal noUi-marker-large" style="left: 0%;"></div>
            <div class="noUi-value noUi-value-horizontal noUi-value-large" style="left: 0%;"></div>
            <div class="noUi-marker noUi-marker-horizontal noUi-marker-large" style="left: 100%;"></div>
            <div class="noUi-value noUi-value-horizontal noUi-value-large" style="left: 100%;"></div>
          </div>
        </div>
        <div class="custom-rangeslider__input">
          <input class="form-control" [id]="'sliderinput'+uniqueId" (change)="onInputChange($event)" type="text" inputmode="numeric" pattern="[0-9]*" value="">
        </div>
      </div>
    </div>
  </div>
</div>

<!-- optional total row: please apply currency formatting as you do with others -->
<!-- <div class="question-panel__total">
<div class="question-panel__total-name">
  <p>Total</p>
</div>
<div class="question-panel__total-amount">
  <p class="font-normal"><strong>R <span data-total="">0</span></strong>/mo</p>
</div>
</div> -->
<!-- /optional total row -->


